import { DEFAULT_LANGUAGE, LocalizedText } from 'apollo/localizedTypes';
import clearEmptyRichText from './clearEmptyRichText';
import mapLocalizedText from './mapLocalizedText';

const mapOptionalLocalizedRichText = (
  value?: LocalizedText
): LocalizedText | undefined => {
  const cleared = clearEmptyRichText(value);
  return cleared[DEFAULT_LANGUAGE] ? mapLocalizedText(cleared) : undefined;
};

export default mapOptionalLocalizedRichText;
